const indexItems = [
  { char: 'A', title: 'APP下载', desc: '每日大赛官方APP多平台下载' },
  { char: 'B', title: '备用入口', desc: '每日大赛备用网址与镜像站点' },
  { char: 'C', title: '常见问答', desc: '每日大赛使用问题解答合集' },
  { char: 'D', title: '登录指南', desc: '每日大赛账号注册与登录教程' },
  { char: 'E', title: 'APP安装', desc: 'Android与iOS安装详细步骤' },
  { char: 'F', title: '访问问题', desc: '无法访问每日大赛的解决方案' },
  { char: 'G', title: '官方公告', desc: '每日大赛官方最新通知汇总' },
  { char: 'H', title: '活动专区', desc: '每日大赛热门活动与赛事入口' },
  { char: 'I', title: 'iOS教程', desc: 'iOS设备每日大赛使用指南' },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            主题索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            按字母快速浏览每日大赛相关主题内容，一站式检索入口资讯
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto">
          {indexItems.map((item) => (
            <a
              key={item.char}
              href={`#cards`}
              className="group flex items-start gap-4 bg-background-50 rounded-xl border border-background-200/70 p-4 hover:border-primary-200 transition-all duration-300"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 font-bold text-sm flex-shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                {item.char}
              </span>
              <div className="min-w-0">
                <h4 className="font-semibold text-sm text-foreground-900 mb-0.5">{item.title}</h4>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}